<template>
    <div class="md:max-w-[46.625rem] md:mx-auto ">
        <div
            v-if="data"
            class="py-4 md:py-6 md:flex items-center"
        >
            <!-- <template v-if="aplCatl===aplCatlCode.E_NOTIFY_PROMO">
                <div class="bg-white hidden md:block w-28 h-28 rounded-full leading-[7rem] text-center flex-shrink-0 mr-5  overflow-hidden ">
                    <SvgIcon
                        icon-name="playlist_add_blue"
                        class="hidden md:block flex-shrink-0 w-[7.5rem] h-[7.5rem] mr-5"
                    />
                </div>
                <div>
                    <Title
                        :text="$route.meta.pageTitle"
                        style-code-page
                        class="md:mb-3"
                    />
                    <p class="h4">
                        預計將於{{ data.completeTime }}完成變更，變更完成將以簡訊或email通知予您。
                    </p>
                </div>
            </template> -->
        </div>
        <SkeletonTitleIcon v-else />
        <transition
            name="opacity"
            mode="out-in"
        >
            <SkeletonFinish v-if="!data" />
            <div
                v-else
                class="ring-1 ring-gray-200 rounded-t-md mb-8"
            >
                <div class="h4 text-white gradient-primary py-2 px-2.5 rounded-t-md md:px-5">
                    您本次申請已受理成功，申請紀錄如下
                </div>
                <div class="md:bg-white">
                    <ul class="divide-y divide-dashed h4 ">
                        <li class="px-2.5 pt-1.5 pb-1 text-gray-700 md:px-5">
                            申請日期：{{ data.transDate }}
                        </li>
                        <li class="px-2.5 pt-1.5 pb-1 text-gray-700 md:px-5">
                            受理案號：{{ data.regiNo }}
                        </li>
                        <li
                            v-if="data.fullPolicyNo"
                            class="px-2.5 pt-1.5 pb-1 text-gray-700 md:px-5"
                        >
                            保單號碼：{{ data.fullPolicyNo }}
                        </li>
                        <!-- <li
                            v-if="data.insuredName"
                            class="px-2.5 pt-1.5 pb-1 text-gray-700 md:px-5"
                        >
                            被保險人：{{ data.insuredName }}
                        </li> -->
                        <li
                            v-if="data.applName && aplCatl===aplCatlCode.E_NOTIFY_PROMO"
                            class="px-2.5 pt-1.5 pb-1 text-gray-700 md:px-5"
                        >
                            要保人：{{ data.applName }}
                        </li>
                        <li
                            v-if="data.beneFiName"
                            class="px-2.5 pt-1.5 pb-1 text-gray-700 md:px-5"
                        >
                            受益人：{{ data.beneFiName }}
                        </li>
                        <li class="px-2.5 pt-1.5 pb-1 text-gray-700 md:px-5">
                            申請項目：{{ data.aplCatlText }}
                        </li>
                        <li class="px-2.5 py-2 text-right md:px-5">
                            <span
                                class="text-link"
                                @click="downloadPDF(data.regiNo)"
                            >列印本次內容</span>
                            <br>
                            <span style="font-size: 16px; color:red;">(請輸入要保人身分證字號開啟下載後的檔案)</span>
                        </li>
                    </ul>
                </div>
            </div>
        </transition>
        <div v-if="data">
            <template v-if="aplCatl===aplCatlCode.PAY_PCC">
                <ol class="text-tip">
                    <li>尚有其他即將給付保險金之保單請點選「選擇其他保單」進行給付帳號約定，或點選「確定」結束作業。</li>
                </ol>
            </template>
            <!-- <DescPayment @goPage="goPage" /> -->
            <div class="flex justify-center space-x-4">
                <button
                    class="btn gradient-primary rounded-full"
                    @click="goHome"
                >
                    確定
                </button>
                <button
                    class="btn gradient-primary rounded-full"
                    @click="goPolicy"
                >
                    選擇其他保單
                </button>
            </div>
        </div>
        <Loading
            :isLoading="isLoading"
            :text="loadingText"
        />
    </div>
</template>

<script>
import { ref, computed, inject } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import routeName from '@/router/constant.js';
import Loading from '@/components/Loading.vue';
import SkeletonTitleIcon from './SkeletonTitleIcon.vue';
import SkeletonFinish from './SkeletonFinish.vue';
import { EUDC } from '@/utils/EUDC';
import { getCompleteData } from '@/apis/system';
import { getPdfRecordToken } from '@/apis/record.js';
import { postInitContinue } from '@/apis/twid';
import aplCatlCode from '@/json/aplCatlCode';

export default {
    components: {
        SkeletonFinish,
        Loading,
        SkeletonTitleIcon
    },
    setup() {
        const $vfm = inject('$vfm');
        const store = useStore();
        const isLoading = ref(false);
        const visiblePopup = ref(false);
        const loadingText = ref('');
        const router = useRouter();
        const data = ref(null);
        const aplCatl = computed(() => store.state.permissions.aplCatl);

        const downloadPDF = (regiNo) => {
            isLoading.value = true;
            getPdfRecordToken(regiNo).then((response) => {
                const token = response.data.token;
                const path = process.env.VUE_APP_API_PATH;
                const baseUrl = `${window.location.origin}${path}`;
                window.open(baseUrl + '/api/transaction/record/downloadPdf?token=' + token, '_blank');
            }).finally(() => {
                setTimeout(() => {
                    isLoading.value = false;
                }, 500);
            });
        };
        const getData = () => {
            isLoading.value = true;
            getCompleteData().then((res) => {
                data.value = res.data;
                EUDC();
            }).catch(err => {
                console.log(err);
                openModal({
                    id: 'error',
                    title: '很抱歉',
                    content: '系統忙碌中，委託受理未完成，請稍後再試，謝謝。',
                    confirmButton: '確認',
                    closeicon: false
                });
            }).finally(() => {
                isLoading.value = false;
            });
        };

        const openModal = (params) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                        if (params.id === 'error') {
                            // router.push({ name: routeName.HOME });
                        }
                    },
                }
            });
        };
        const goHome = () => {
            store.dispatch('permissions/goFubonOfficial');
        };

        const goPolicy = () => {
            isLoading.value = true;
            const returnData = {
                regiNo: data.value.regiNo,
            };
            postInitContinue(returnData).then((res) => {
                store.dispatch('permissions/setAplCatl', aplCatl.value);
                store.dispatch('permissions/setTransactionId', res.data.transactionUniqueId);
                store.dispatch('policy/resetChangeItemsResult');
                router.push({ name: routeName.PAYACC_SELECT_POLICY });
            }).catch(err => {
                console.log(err);
            }).finally(() => {
                isLoading.value = false;
            });
        };

        // const goPage = (link) => {
        //     router.push({
        //         name: link
        //     });
        // };

        getData();

        return {
            data,
            downloadPDF,
            routeName,
            isLoading,
            loadingText,
            visiblePopup,
            aplCatl,
            aplCatlCode,
            goHome,
            goPolicy,
        };
    }
};
</script>
